import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import { DashboardController } from "../../controllers";
import {
  CustomModal,
  EmptyTable,
  Input,
  Layout,
  PolicyInfo,
  TableRowResponsive,
} from "../../components";
import { Accordion, AccordionSummary, LinearProgress } from "@mui/material";
import {
  Arrowleft,
  Calendar4,
  CallCalling,
  Cancel,
  MoneyTime,
  PersonalCard,
  Prerenderbg2,
  SelectMultiple,
  TrendUp,
  vector4,
} from "../../../assets";
import "chart.js/auto";
import routes from "../../../core/routes";
import { Link } from "react-router-dom";
import "swiper/css/pagination";
import { numberWithCommas } from "../../../core/utils";
import { Button } from "../../components/button";

class Dashboard extends DashboardController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getList();
  }
  render() {
    const {
      loading,
      DashboardsList,
      openModal,
      price,
      clickLoading,
      shareHolder,
    } = this.state;
    return (
      <Layout noBg noPadding title="داشبورد کاربری">
        <Helmet>
          <title> داشبورد کاربری | بیمه زندگی هامرز</title>
        </Helmet>
        {loading ? (
          <LinearProgress />
        ) : (
          <div className="dashboard scrollbar ps-0">
            <div className="file-information">
              <div className="file-information-headline">
                <div className="title">اطلاعات سهامدار</div>
              </div>
              <div className="total-card-container">
                <PolicyInfo
                  icon={vector4}
                  myStyle="col-lg-3 col-sm-6 col-6 "
                  title="نام و نام خانوادگی"
                  subTitle={`${DashboardsList?.first_name || ""}  ${
                    DashboardsList?.last_name || ""
                  }`}
                />
                <PolicyInfo
                  icon={SelectMultiple}
                  myStyle="col-lg-3 col-sm-6 col-6"
                  title="کد ملی"
                  subTitle={DashboardsList?.national_code}
                />
                <PolicyInfo
                  icon={Calendar4}
                  myStyle="col-lg-3 col-sm-6 col-6"
                  title="تاریخ تولد"
                  subTitle={DashboardsList?.birth_date || ""}
                />
                <PolicyInfo
                  icon={CallCalling}
                  myStyle="col-lg-3 col-sm-6 col-6"
                  title="شماره همراه"
                  subTitle={DashboardsList?.phone_number || "----"}
                />
                <PolicyInfo
                  icon={TrendUp}
                  myStyle="col-lg-3 col-sm-6 col-6"
                  title="تعداد سهام"
                  subTitle={
                    numberWithCommas(DashboardsList?.deposit_share) || "0"
                  }
                />
                <PolicyInfo
                  icon={MoneyTime}
                  myStyle="col-lg-3 col-sm-6 col-6"
                  title="کد سهامداری"
                  subTitle={DashboardsList?.share_code || "----"}
                />
                <PolicyInfo
                  icon={MoneyTime}
                  myStyle="col-lg-3 col-sm-6 col-6"
                  title="تعداد سهام تادیه نشده"
                  subTitle={
                    numberWithCommas(DashboardsList?.debit_amount) || "0"
                  }
                />
                <PolicyInfo
                  icon={MoneyTime}
                  myStyle="col-lg-3 col-sm-6 col-6"
                  title="مانده مبلغ تادیه"
                  subTitle={
                    DashboardsList?.debit_share_settlements_price
                      ? `${numberWithCommas(
                          DashboardsList.debit_share_settlements_price
                        )} ریال`
                      : "0"
                  }
                />
              </div>
            </div>
            <div className="dashboard-content">
              <div className="right-side">
                <div className="active-policy">
                  <div className="dashboard-content-title-status">
                    <span className="title">لیست تراکنش ها</span>

                    <Button
                      onClick={() => this.setState({ openModal: !openModal })}
                      title="واریز تادیه"
                      myStyle="w-10"
                    />
                  </div>

                  <div className="policy table-responsive scrollbar offers">
                    <table className="table hide-mobile">
                      <thead>
                        <tr>
                          <th scope="col">ردیف</th>
                          <th scope="col"> مبلغ</th>
                          <th scope="col">تعداد سهم</th>
                          <th scope="col">تاریخ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {DashboardsList?.share_settlements?.length > 0 &&
                          DashboardsList?.share_settlements?.map(
                            (item: any, index: number) => {
                              return (
                                <tr>
                                  <td>{index + 1}</td>
                                  <td>
                                    {numberWithCommas(item?.deposit_amount) || "----"}
                                  </td>
                                  <td>{item?.stock_amount || "----"} </td>
                                  <td>{item?.date || "----"} </td>
                                </tr>
                              );
                            }
                          )}
                      </tbody>
                    </table>

                    {DashboardsList?.share_settlements?.length > 0 ? (
                      <>
                        {DashboardsList?.share_settlements?.map(
                          (item: any, index: number) => {
                            return (
                              <Accordion expanded={false} className="policy-accordion hide-desktop">
                                <AccordionSummary
                                  aria-controls="panel1a-content"
                                  className="summsry"
                                  id="panel1a-header"
                                >
                                  <TableRowResponsive
                                    title="ردیف"
                                    value={index + 1}
                                  />
                                  <TableRowResponsive
                                    title=" مبلغ"
                                    value={numberWithCommas(
                                      item?.deposit_amount || "----")}
                                  />
                                  <TableRowResponsive
                                    title="تعداد سهم"
                                    value={item?.stock_amount || "----" }
                                  />
                                  <TableRowResponsive
                                    title="تاریخ"
                                    value={item?.date || "----"}
                                  />
                                </AccordionSummary>
                              </Accordion>
                            );
                          }
                        )}
                        <div className="all">
                          <Link to={routes.TRANSACTION} className="all-text">
                          همه
                          <Arrowleft myStyle="arrow" />
                        </Link>
                        </div>
                        
                      </>
                    ) : (
                      <EmptyTable title="   تراکنشی ثبت نشده است " />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <CustomModal
          myStyle="vertical-content-modal"
          openModal={openModal}
          onClose={() =>
            this.setState({
              openModal: false,
              price: this.props.dashboardData?.debit_share_settlements_price || null,
              shareHolder: this.props.dashboardData?.debit_amount || null,
            })}

          
        >
          <>
            <div className="custom-modal-main-title hide-desktop ">
              <h1 className="title"> واریز تادیه </h1>
              <Cancel
                myStyle="ps-2 "
                width="20"
                height="20"
                color="#000000"
                onClick={() => this.setState({ openModal: !openModal })}
              />
            </div>
            <div className="filter-selected">
              <div>
                <span className="text ml-50 hide-mobile bold">
                  {" "}
                  واریز تادیه{" "}
                </span>{" "}
              </div>
              <Cancel
                myStyle="hide-mobile cursor-pointer"
                onClick={() => this.setState({ openModal: !openModal })}
              />
            </div>
            <img src={Prerenderbg2} alt="هامرز" className="W-100 image" />
            <div className="info-group">
              <span className="pre-payment-title">
                لطفا تعداد سهم را وارد کنید.
              </span>

              <div className="w-100 mt-33 mb-5">
                <Input
                  hideEndAdornment
                  type="number"
                  myStyle="w-100"
                  title="تعداد سهم"
                  value={shareHolder}
                  onChange={this.handleChangeShareHolder}
                  icon={<PersonalCard />}
                />

                <Input
                  hideEndAdornment
                  type="number"
                  disabled
                  myStyle="w-100"
                  title="مبلغ به ریال"
                  value={numberWithCommas(price) ?? ""}
                  icon={<PersonalCard />}
                />
              </div>

              <div className="d-flex justify-content-end w-100">
                <Button
                  myStyle="bg-blue pre-payment-btn"
                  title="پرداخت"
                  disabled={!price}
                  onClick={() => this.create()}
                  loading={clickLoading}
                />
              </div>
            </div>
          </>
        </CustomModal>
      </Layout>
    );
  }
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
    dashboardData: dispatch.general.dashboardData,
  };
};

export default connect(mapStateToProps)(Dashboard);
